import { AuthGuard, roleGuard } from "@dis/auth";
import { JtmsRoutes, groupOverview } from "../core/routing/route-data";

// Admin-only for now. A separate DEV ACL scope would also grant company-wide reads (any global grant
// passes the read @auth rules), so it waits until non-admins need these pages.
export default [
  {
    path: "",
    // AuthGuard first: the router acts on the first non-true result in array order.
    canMatch: [AuthGuard, roleGuard(["admin", "super_admin"])],
    data: { navGroup: "dev", adminOnly: true },
    children: [
      groupOverview(),
      {
        path: "forms",
        data: { navOrder: 1 },
        loadComponent: () =>
          import("../testing/form-testing/form-testing.component").then((m) => m.FormTestingComponent),
        title: "Form Testing",
      },
      {
        path: "callable-functions",
        data: { navOrder: 2 },
        loadComponent: () =>
          import("../testing/callable-functions/callable-functions").then((m) => m.CallableFunctions),
        title: "Callable Functions",
      },
      {
        // The legacy route's project outlet is dead (no named outlet, resolver always returns false), so it isn't carried over.
        path: "dataconnect",
        data: { navOrder: 3 },
        loadComponent: () =>
          import("../feature/dataconnect/dataconnect/dataconnect.component").then((m) => m.DataConnectTestingComponent),
        title: "Data Connect Testing",
      },
      {
        // Full-page copy of the header search modal's results.
        path: "search-results",
        data: { navOrder: 4 },
        loadComponent: () =>
          import("../feature/search-bar/search-bar-results/search-bar-results").then((m) => m.SearchBarResults),
        title: "Search Results",
      },
    ],
  },
] satisfies JtmsRoutes;
